module.exports = "https://r.nearpod.com/assets/media/image/video-1a656ed24f4e8068c50b8a1dff60d82a.svg";